import { render, staticRenderFns } from "./OrderTD1.vue?vue&type=template&id=168f3702&scoped=true&"
import script from "./OrderTD1.vue?vue&type=script&lang=js&"
export * from "./OrderTD1.vue?vue&type=script&lang=js&"
import style0 from "./OrderTD1.vue?vue&type=style&index=0&lang=less&"
import style1 from "./OrderTD1.vue?vue&type=style&index=1&id=168f3702&lang=less&scoped=scoped&"
import style2 from "./OrderTD1.vue?vue&type=style&index=2&id=168f3702&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f3702",
  null
  
)

export default component.exports